import React from 'react';
// import YoutubeBackground from 'react-youtube-background'
import {Link} from "react-router-dom";

const IntroTwo = () => {
    return (
            // <YoutubeBackground
            //     // videoId="eS9Qm4AOOBY"
            //     // videoId="-MKapbz0GIo"
            //     // videoId="_7YP4GVRvK8"
            //     videoId="BqFSHbzSs7U"
            //     overlay="rgba(0,0,0,.4)"
            //     className="intro-section section bg-video"
            // >
<>          
          
            <video  className='overlay-two' id="HomeBanner"
            autoPlay={true}
            muted
            loop
            playsInline={true}
         >  
         <source src="images/imageTrails/Home/HeroBanner/Hero.mp4"/> 
        </video>
              
                <div className=" overlay-two home-banner-video" style={{width:'100%', height:'100vh'}}>
                    <div className="row row-cols-lg-1 row-cols-1" style={{marginRight:'0px'}}>

                        <div className="col align-self-center" style={{marginTop:'15%'}}>
                            <div className="intro-content-two text-center mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
                                <h2 className="title homepage-hero-title" style={{fontSize:'3.5rem', marginBottom:'7px'}}>We Make Inter Office Communication Efficient</h2>
                                <div className="desc homepage-hero-desc" >
                                    <p>Quick and effortless way to communicate in your workplace</p>
                                </div>
                                {/* <Link to={process.env.PUBLIC_URL + "/"} className="btn btn-primary btn-hover-secondary">Get Started</Link> */}
                                <Link to={process.env.PUBLIC_URL + "/yant"} id="btn_hover" className="btn  btn-primary btn-blue" style={{marginTop:'40px'}}>Check Out Yant!</Link>
                            </div>
                        </div>

                    </div>
                </div>
              
                </>
              
    )
}


export default IntroTwo;
